import { Button, PaddedContainer, SPACING } from "@disco/disco_core";
import React from "react";
import useEssentialWidgetOffer from "../../hooks/useEssentialWidgetOffer";
import useDimensions from "../../hooks/useDimensions";
import getParsedRedirectUrl from "../../utils/getParsedRedirectUrl";
import windowRedirect from "../../utils/windowRedirect";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import {
	BRAND_CLICK_TARGET,
	WIDGET_ELEMENT_CLICK_TARGET,
} from "../../event_conf";

const EssentialWidgetOfferAction = () => {
	const {
		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,
		activeOffer,
		claimOffer,

		handleWidgetCardClose,

		defaultOfferEventProps,
	} = useEssentialWidgetOffer();

	const { inDesktopOnly } = useDimensions();
	const track = useTrack();

	const {
		incentive_landing_page_url: incentiveLandingPageUrl,
		incentive_cta_text: primaryCtaText,
	} = activeOffer;
	const offerRedirectUrl = getParsedRedirectUrl({
		brand: activeOffer,
		redirectUrl: incentiveLandingPageUrl,
	});

	const handleOfferClaim = () => {
		windowRedirect({ url: offerRedirectUrl });
		claimOffer();
	};

	const navigateToNext = () => {
		if (isLastOffer) {
			handleWidgetCardClose();
			return;
		}
		showNextOffer();
	};

	const handlePrimaryClick = () => {
		track(eventTypes.CLICK_BRAND, {
			...defaultOfferEventProps,
			brand_redirect_link: offerRedirectUrl,
			initiatingTarget: BRAND_CLICK_TARGET.INLINE_ACTION_BUTTON,
			isInternalClick: false,
		});

		const NAVIGATION_DELAY = 800;
		// To allow document visibility state to update, prevents premature event firing
		setTimeout(() => {
			navigateToNext();
		}, NAVIGATION_DELAY);

		handleOfferClaim();
	};

	const handleSecondaryClick = () => {
		track(eventTypes.WIDGET_ELEMENT_CLICK, {
			...defaultOfferEventProps,
			initiatingTarget: WIDGET_ELEMENT_CLICK_TARGET.INLINE_NAV_FORWARD,
		});
		navigateToNext();
	};

	const primaryBtnCopy = primaryCtaText;
	const secondaryBtnCopy = "No thanks";

	return (
		<PaddedContainer
			flexContent
			alignContentCenter={inDesktopOnly}
			style={{ flexDirection: inDesktopOnly ? "row" : "column" }}
		>
			<Button
				rounded={false}
				onClick={handlePrimaryClick}
				style={{
					"--bg": "var(--disco-facebook)",
					"--border-color": "transparent",
					...(!inDesktopOnly && {
						flexGrow: 1,
						justifyContent: "center",
					}),
				}}
			>
				{primaryBtnCopy}
			</Button>
			<Button
				secondary
				rounded={false}
				marginTop={!inDesktopOnly && SPACING.TINY}
				marginLeft={inDesktopOnly && SPACING.TINY}
				onClick={handleSecondaryClick}
				style={{
					"--color": "var(--disco-facebook)",
					"--border-color": "transparent",
					boxShadow: "unset",
					...(!inDesktopOnly && {
						flexGrow: 1,
						justifyContent: "center",
					}),
				}}
			>
				{secondaryBtnCopy}
			</Button>
		</PaddedContainer>
	);
};

export default EssentialWidgetOfferAction;
